function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m18.667 58.667h-5.3333a8 8 0 0 1-8-8v-37.333a8 8 0 0 1 8-8h5.3333a2.6667 2.6667 0 1 0 0-5.3333h-5.3333a13.349 13.349 0 0 0-13.333 13.333v37.333a13.349 13.349 0 0 0 13.333 13.333h5.3333a2.6667 2.6667 0 0 0 0-5.3333z",
    fill: "currentColor",
    style: {
      strokeWidth: 2.6667
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.767 49.885 12.232-12.229a8.0187 8.0187 0 0 0 0-11.312l-12.232-12.229a2.6667 2.6667 0 1 0-3.7707 3.7707l11.445 11.448h-41.109a2.6667 2.6667 0 0 0 0 5.3333h41.112l-11.448 11.448a2.6667 2.6667 0 1 0 3.7707 3.7707z",
    fill: "currentColor",
    style: {
      strokeWidth: 2.6667
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOut);
export default __webpack_public_path__ + "static/media/sign-out.db2d5a31.svg";
export { ForwardRef as ReactComponent };